
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parkful-pro",
      function () {
        return require("private-next-pages/parkful-pro.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parkful-pro"])
      });
    }
  